import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, Axios)

import {
  DropdownMenu,
  DropdownItem,
  Dialog
} from 'vant';
import {
  Cell,
  CellGroup
} from 'vant';
import {
  Icon
} from 'vant';
import {
  Search
} from 'vant';
import {
  Toast
} from 'vant';
import {
  Button
} from 'vant';
import { Field } from 'vant';
import { Form } from 'vant';
import { Popup } from 'vant';
import { Area } from 'vant';
import { Picker } from 'vant';
import { Overlay } from 'vant';
Vue.use(Overlay);
Vue.use(Picker);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dialog);
Vue.use(Toast);


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
